import React, { useContext } from 'react';
import { Banner } from './banner';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { AlertContext, QueuedMessage } from './alert-context';
import styles from './alert.css';

interface AlertProps {
  /** Custom className to add to the banner container */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Alert Component with built in Tranition
 *
 * @param {AlertProps} param
 *
 * @return JSX.ELEMENT
 */
export const Alert = ({ className, 'data-testid': dataTestId }: AlertProps) => {
  const { alerts } = useContext(AlertContext);
  const nodeRef = React.useRef(null);
  return (
    <div className={className} data-testid={dataTestId}>
      <TransitionGroup className={styles.container}>
        {Object.values(alerts).map((alert: QueuedMessage, i: number) => (
          <CSSTransition nodeRef={nodeRef} classNames={'alerts__banner'} timeout={200} key={i}>
            <Banner ref={nodeRef} type={alert.type} onClose={alert.dismiss}>
              {alert.message}
            </Banner>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </div>
  );
};
